/* Pattern for ad hoc query against relay store */
import { fetchQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();
      
const query = graphql`
query AccountBudgetFetchQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    accountType
    accountStatus
    useBudgets
    autoTopupAmount
    walletTsByAccountId {
      totalCount
    }
  }
}
`;

function fetch(acctId) {
  const variables = {
    accountId: acctId
  }
  
  return fetchQuery(
    abEnvironment.getEnvironment(),
    query,
    variables
  );
}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { fetch };

